module.exports = __webpack_public_path__ + "img/pc-id.ef9ba59e.jpg";